/* ─── Design Tokens ─── */
export const C = {
  primary: "#ec5b13",
  pL: "rgba(236,91,19,.1)",
  dark: "#221610",
  bg: "#f8f6f6",
  w: "#ffffff",
  bdr: "#e8e2df",
  t1: "#1e1e1e",
  t2: "#78716c",
  t3: "#a8a29e",
  green: "#16a34a",
  red: "#ef4444",
  teal: "#0d9488",
  indigo: "#6366f1",
  amber: "#f59e0b",
};

export const NAV = [
  { key: "dashboard", icon: "dashboard", label: "Dashboard", path: "/" },
  { key: "conversations", icon: "chat", label: "Conversations", path: "/conversations", badge: 5 },
  { key: "contacts", icon: "people", label: "Contacts", path: "/contacts" },
  { key: "cta-pipeline", icon: "view_kanban", label: "CTA Pipeline", path: "/pipeline" },
  { key: "scheduling", icon: "calendar_month", label: "Scheduling", path: "/scheduling" },
  { key: "api-hub", icon: "hub", label: "API Hub", path: "/api-hub" },
  { key: "knowledge-base", icon: "database", label: "Knowledge Base", path: "/knowledge-base" },
  { key: "ai-settings", icon: "smart_toy", label: "AI Settings", path: "/settings" },
];
